import napStyles from './../nap.json'

export default {
  color: napStyles.colors.PrimaryBlack,
  inverseColor: napStyles.colors.PrimaryWhite,
  lineHeight: 2
}
